import { Directive, HostListener, ElementRef, Renderer2 } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appFax]',
  standalone: true
})
export class FaxDirective {

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private control: NgControl
  ) {}

  @HostListener('input')
  @HostListener('paste')
  @HostListener('blur')
  onInput() {
    setTimeout(() => this.formatAndValidate(), 0);
  }

  private formatAndValidate() {
    const input = this.el.nativeElement;
    let value = input.value || '';
    let digits = value.replace(/\D/g, '').substring(0, 10);
    let formatted = digits;

    if (digits.length >= 7) {
      formatted = digits.substring(0, 3) + '-' + digits.substring(3, 6) + '-' + digits.substring(6);
    } else if (digits.length >= 4) {
      formatted = digits.substring(0, 3) + '-' + digits.substring(3);
    }

    if (input.value !== formatted) {
      this.renderer.setProperty(input, 'value', formatted);
      this.control.control?.setValue(formatted, { emitEvent: false });
    }

    this.control.control?.markAsTouched();
    this.control.control?.markAsDirty();
    this.control.control?.updateValueAndValidity();
  }
}